/* @flow */
import * as React from 'react';
import Confetti from 'components/Confetti';
import { withRouter } from 'app/context/Router';
import AdminUpgradeInformationalPage from 'admin/components/AdminUpgradeInformationalPage';
import AdminUpgradeCompleteButton from 'admin/components/AdminUpgradeCompleteButton';

type Props = {
  router: *,
};

class AdminUpgradeConfirmationPage extends React.Component<Props> {
  render() {
    const { action_needed: actionNeeded } = this.props.router.location.query;

    const subtext =
      actionNeeded === 'true'
        ? 'Our School Success Team will send you an invoice for your purchase. We’ll enable your Remind School Plan features and send you instructions on how to roll out Remind to your school once payment has been received. In the meantime, sign in to Remind and send your first few messages!'
        : 'Our School Success Team will begin turning on School Plan features for your school within two business days. You’ll receive a series of emails with next steps for rolling out Remind at your school. Our team may contact you by email in order to verify your status as an administrator.';

    return (
      <AdminUpgradeInformationalPage
        title="Thank you."
        subtext={subtext}
        action={<AdminUpgradeCompleteButton />}>
        <Confetti />
      </AdminUpgradeInformationalPage>
    );
  }
}

export { AdminUpgradeConfirmationPage };
export default withRouter(AdminUpgradeConfirmationPage);
